import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deleteUnitApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const deleteUnit = createAsyncThunk('deleteUnit', async (payload) => {
  return await deleteUnitApi(payload);
});

const deleteUnitSlice = createSlice({
  name: 'deleteUnit', // Unique Name
  initialState,
  reducers: {
    deleteUnitReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteUnit.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(deleteUnit.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(deleteUnit.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { deleteUnitReset } = deleteUnitSlice.actions;

export default deleteUnitSlice.reducer;
